export default __webpack_public_path__ + "static/media/Futura-Demi.2ac089b9.woff2";